module.exports = __webpack_public_path__ + "static/fukubaka0825-c1d132fee6d7f421f1740aa72ca54805.jpg";